import {PaymentProvider} from '../../shared/enums/PaymentProvider';

export class SetProviderForChannelRequest {
  public paymentProvider: PaymentProvider;
  public status: boolean;
}
